import { getUseCaseLimitation } from '@src/components/common/Dashboard/UseCases/limitation';
import { isAppModule } from '@utils/constants';

export const getApplicableDimensionsForPreset = (
  usecaseKey: string,
  dimensions: Record<string, string>[],
) => {
  const limitation = getUseCaseLimitation(usecaseKey);

  if (isAppModule && limitation) {
    const { excludeCategories = [], excludeTypes = [] } = limitation?.dimensions || {};
    return dimensions.filter((it) => {
      return !excludeCategories.includes(it.category) && !excludeTypes.includes(it.type);
    });
  }

  return dimensions;
};
